import "./areaAjuda.css";
import { IoDocumentTextOutline } from "react-icons/io5";
import { MdOutlineSupportAgent } from "react-icons/md";
import { LuHelpingHand } from "react-icons/lu";
import { FaRegHandshake } from "react-icons/fa6";

const AreaAjuda = () => {
  return (

    <section class="ajuda-section" id="atendimento">
        <div class="container-ajuda">
            <div class="section-header-ajuda">
                <h2>Precisa de ajuda?</h2>
                <p>Conte com nossa equipe especializada para resolver suas dúvidas e problemas com agilidade e eficiência</p>
            </div>

            <div class="ajuda-grid">
              
                <div class="ajuda-card">
                    <div class="card-icon">
                        <i class="fas fa-file-invoice-dollar"></i>
                    </div>
                    <h3>2ª Via de Boleto</h3>
                    <p>Emita a segunda via da sua fatura de forma rápida e prática sem sair de casa</p>
                    <a href="https://geraisnet.ispfycloud.com.br/" class="card-link">Emitir agora →</a>
                </div>

               
                <div class="ajuda-card">
                    <div class="card-icon">
                        <i class="fas fa-headset"></i>
                    </div>
                    <h3>Atendimento</h3>
                    <p>Nossa equipe está disponível para esclarecer dúvidas sobre sua conta e serviços</p>
                    <a href="https://wa.me/5538998988942" class="card-link">Falar com atendente →</a>
                </div>

                
                <div class="ajuda-card">
                    <div class="card-icon">
                        <i class="fas fa-tools"></i>
                    </div>
                    <h3>Suporte Técnico</h3>
                    <p>Problemas com conexão? Nossa equipe técnica resolve com rapidez e eficiência</p>
                    <a href="https://wa.me/5538998988942" class="card-link">Abrir chamado →</a>
                </div>

               
                <div class="ajuda-card">
                    <div class="card-icon">
                        <i class="fas fa-shopping-cart"></i>
                    </div>
                    <h3>Vendas</h3>
                    <p>Contrate os melhores planos de internet com condições especiais para você</p>
                    <a href="#planos" class="card-link">Ver planos →</a>
                </div>
            </div>

            <div class="contato-rapido">
                <h3>Atendimento Rápido</h3>
                <p>Entre em contato conosco através dos canais abaixo</p>
                
                <a href="tel:+5538998988942" class="telefone-destaque">
                    <i class="fa fa-phone"></i> (38) 99898-8942
                </a>

                <div class="cta-buttons">
                    <a href="https://wa.me/5538998988942" target="_blank" class="btn btn-whatsapp">
                        <i class="fab fa-whatsapp"></i> WhatsApp
                    </a>
                    <a href="#planos" class="btn btn-planos">
                        <i class="fas fa-wifi"></i> Ver Planos
                    </a>
                </div>

                <div class="horario-atendimento">
                    <p><strong>Horário de atendimento:</strong> Segunda a Sexta, das 8h às 16h</p>
                </div>
            </div>
        </div>
    </section>

  );
};

export default AreaAjuda;
